<template>
  <van-row class="home">
    <div class="form">
      <van-col justify="center" align="center" span="24">
        <van-image
          class="logo"
          src="//image-1252304461.cos.ap-beijing.myqcloud.com/image/29.png"
        />
      </van-col>
      <van-col class="login_box" justify="center" align="center" span="24">
        <van-cell-group inset>
          <van-field v-model="username" placeholder="请输入用户名" />
          <van-field v-model="password" placeholder="请输入密码" />
        </van-cell-group>
      </van-col>
      <van-button class="login" @click="userLogin" block type="primary"
        >登录</van-button
      >
    </div>
  </van-row>
</template>
<script>
import { login } from "@/common/api";
import watermark from "watermark-dom";
export default {
  data() {
    return {
      username: "",
      password: "",
    };
  },
  methods: {
    // 用户登录
    async userLogin() {
      const { username, password } = this;
      let response = await login({ username, password, type: "YG" });
      if (response?.success) {
        localStorage.setItem("currentUser", JSON.stringify(response?.data));
        this.$router.push("/home");
      }
    },
  },
  mounted() {
    watermark.init({
      watermark_txt: "正安中医",
      watermark_angle: 30,
    });
  },
};
</script>
<style lang="less" scoped>
.home {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #f5f5f5;
  .form {
    width: 90vw;
    .logo {
      width: 100px;
      height: 100px;
    }
    .login_box {
      margin-top: 50px;
      background: white;
      border-radius: 8px;
      margin-bottom: 50px;
      .login {
        border-radius: 10px;
      }
    }
  }
}
</style>
